import { render } from "./RegNavbar.vue?vue&type=template&id=106cb721&scoped=true"
import script from "./RegNavbar.vue?vue&type=script&lang=js"
export * from "./RegNavbar.vue?vue&type=script&lang=js"

import "./RegNavbar.vue?vue&type=style&index=0&id=106cb721&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-106cb721"]])

export default __exports__